const News = () => {
   return (
      <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
         <path fill="#146EF5" fillRule="evenodd" d="M8.25 3.75h-6v1.5h6v-1.5zm-6 3h6v1.5h-6v-1.5zm6 3h-6v1.5h6v-1.5zm0 3h-6v1.5h6v-1.5zm6-7.5v7.5h-3v-7.5h3zm-4.5-1.5h6v10.5h-6V3.75z" clipRule="evenodd"></path>
      </svg>
   )
}
export default News;